<template>
  <div class="container">
  <b-row>
    <b-col>
      <h1 class="center">Detalhes do Terapeuta</h1>

      <h4 for="therapist-photo">{{ therapist.name }}</h4>
      <b-card img-width="240px" :img-src="therapist.photoUrl || noPhoto" img-alt="Foto do terapeuta" img-left class="mb-3">
        <b-card-text class="card-text">
            {{ therapist.selfDescription }}
        </b-card-text>
      </b-card>

      <b-form-row>
        <label for="therapistEmails" class="col-sm-2 col-form-label">
          <strong>Emails de contato</strong>
        </label>
        <b-col sm="10">
          <b-form-input id="therapistEmails" plaintext readonly v-model="therapist.emails"/>
          
        </b-col>
      </b-form-row>

      <b-form-row>
        <label for="address" class="col-form-label">
          <strong>Endereço</strong>
        </label>
        <b-col>
          <b-form-input id="address" plaintext readonly v-model="fullAddress"/>
        </b-col>
      </b-form-row>

      <b-form-row>
        <label for="phoneNumber" class="col-sm-2 col-form-label">
          <strong>Telefone</strong>
        </label>
        <b-col sm="10">
          <b-form-input id="phoneNumber" plaintext readonly v-model="therapist.phoneNumber"/>
        </b-col>
      </b-form-row>

      <b-form-row>
        <label class="col-sm-2 col-form-label">
          <strong>Redes sociais</strong>
        </label>
        <b-col  sm="6">
          <a v-if="therapist.whatsappNumber" 
            target="_blank" class="icon-wrapper" 
            :href="`https://api.whatsapp.com/send?phone=${therapist.whatsappNumber}`"
          >
            <img :src="whatsappIcon" alt="whatsapp" class="icon"/>
          </a>
          <a v-if="therapist.instagramProfileName" 
            target="_blank" class="icon-wrapper" 
            :href="`https://www.instagram.com/${therapist.instagramProfileName}`"
          >
            <img :src="instagramIcon" alt="instagram" class="icon"/>
          </a>
          <a v-if="therapist.facebookProfileName" 
            target="_blank" 
            class="icon-wrapper" 
            :href="`https://www.facebook.com/${therapist.facebookProfileName}`"
          >
            <img :src="facebookIcon" alt="facebook" class="icon"/>
          </a>
        </b-col>

      </b-form-row>

      <b-form-row>
        <label class="col-sm-2 col-form-label" for="site">
          <strong>Website</strong>
        </label>
        <b-col v-if="therapist.siteUrl" sm="3">
          <a :href="therapist.siteUrl">{{ therapist.siteUrl}}</a>
        </b-col>
      </b-form-row>
    </b-col>
  </b-row>   

  </div>
</template>

<script>
import * as therapistsApiClient from '../js/therapistsApiClient'
import noPhoto from '../assets/images/no-photo.png'
import whatsappIcon from '../assets/images/whatsapp-icon.svg'
import instagramIcon from '../assets/images/instagram-icon.svg'
import facebookIcon from '../assets/images/facebook-icon.png'
import Vue from 'vue'

export default {
  name: 'TherapistDetails',
  async mounted() {
    const getTherapistResponse = await therapistsApiClient.getTherapist(this.$route.params.id);
    
    if (!getTherapistResponse.success) {
      Vue.$toast.error(`Erro ao buscar detalhes do terapeuta.\n Motivo: ${getTherapistResponse.errors[0]?.message}`);
    }
    
    this.therapist = getTherapistResponse.data;
  },
  data() {
    return {
        therapist: {},
        noPhoto,
        whatsappIcon,
        instagramIcon,
        facebookIcon
    }
  },
  computed: {
    fullAddress: function() {
      const address = `${this.therapist.address || ''}, ${this.therapist.brazilianCity}, ${this.therapist.brazilianState}`;
      console.log(address);
      return address;
    }
  }

}
</script>

<style scoped>

.card-text {
  width: 100%;
  word-break: normal;
  white-space: normal;
}

.photo {
  width: 240px;
  height: auto;
}

h1 {
  margin-top: 20px;
}

.center {
  text-align: center;
}

.icon {
  width: 30px;
  height: auto;
}

.icon-wrapper {
  margin-right: 30px;
}

.container {
  margin-bottom: 50px;
}

</style>
